export class NBIKpis {
  public NBI_NBI = "nbi_nbi";
  public NBI_YTD = "nbi_ytd";
  public NBI_YTD_1 = "nbi_ytd_1";
  public NBI_YTD_2 = "nbi_ytd_2";
  public NBI_YTD_3 = "nbi_ytd_3";
  public NBI_YTD_IB = "nbi_ytd_ib";
  public NBI_YTD_IB_1 = "nbi_ytd_ib_1";
  public NBI_YOY = "nbi_yoy";
  public NBI_FY = "nbi_fy";
  public NBI_FY_1 = "nbi_fy_1";
  public NBI_FY_IB_1 = "nbi_fy_1";
  public NBI_FY_2 = "nbi_fy_2";
  public NBI_FY_IB_2 = "nbi_fy_2";
  public NBI_FY_3 = "nbi_fy_3";
  public NBI_FY_IB_3 = "nbi_fy_3";
  public NBI_QTD = "nbi_qtd";
  public NBI_QTD_1 = "nbi_qtd_1";
  public NBI_MTD = "nbi_mtd";
  public NBI_MTD_1 = "nbi_mtd_1";
  public RWA = "nbi_rwa_eop";
  public RWA_BY_DATE = "rwa_date";
  public NBI_RWA_1 = "nbi_rwa_1";
  public NBI_RWA_2 = "nbi_rwa_2";
  public NBI_RWA_3 = "nbi_rwa_3";
  public NBI_RWA_AVG = "nbi_rwa_avg";
  public NBI_RWA_AVG_FY_1 = "nbi_rwa_fy_1";
  public NBI_RWA_AVG_FY_2 = "nbi_rwa_fy_2";
  public NBI_RWA_AVG_FY_3 = "nbi_rwa_fy_3";
  public NBI_FORECAST_RWA_Y1 = "nbi_forcast_rwa_y1";
  public NBI_FORECAST_RWA_IB_Y1 = "nbi_forcast_rwa_y1";
  public NBI_RGCP = "nbi_rgcp";
  public NBI_RGCP_1 = "nbi_rgcp_1";
  public NBI_RGCP_YTD = "nbi_rgcp_ytd";
  public NBI_FORECAST_RGCP_Y1 = "nbi_forcast_rgcp_y1";
  public NBI_RGCP_FY_2 = "nbi_rgcp_fy_2";
  public NBI_RGCP_FY_3 = "nbi_rgcp_fy_3";
  public NBI_Y_VS_Y1 = "nbi_y_v_y1";
  public NBI_GBIS_BUB_OBJ = "nbi_gbis_bud_obj";
  public NBI_GBIS_BUB_OBJ_1 = "nbi_gbis_bud_obj_1";
  public NBI_GBIS_BUB_OBJ_IB = "nbi_gbis_bud_obj_ib";
  public NBI_FORECAST_Y1 = "nbi_forcast_y1";
  public NBI_FORECAST_IB_Y1 = "nbi_forcast_y1";
  public NBI_PSM_NBI = "nbi_psm_nbi";
  public NBI_PSM_RWA = "nbi_psm_RWA";
  public NBI_FORECAST_RGCP_H1_1 = "nbi_forecast_rgcp_h1_1";
  public NBI_FORECAST_RGCP_Y1_1 = "nbi_forecast_rgcp_y1_1";
}
